const addressField = {
  component: 'FormField',
  form: {
    component: 'AddressForm',
  },
  elevate: true,
};

export default addressField;
